import APIService, { IPrediction } from 'services/APIService';
import { useState, useEffect } from 'react';

type PredictionTemplateData = {
    prediction: IPrediction;
    countryName: string;
};

const usePredictionTemplate = (predictionId: string) => {
    const [data, setData] = useState<PredictionTemplateData>({ prediction: null, countryName: null });

    useEffect(() => {
        (async () => {
            if (!predictionId) {
                return;
            }
            const prediction = await APIService.getFullPrediction(predictionId);
            const country = await APIService.getActiveCountries().then(data => data.countries[prediction.country_id]);
            const countryName = country.name;
            setData({ prediction, countryName });
        })();
    }, [predictionId]);

    return data;
};

export default usePredictionTemplate;
